// removed by extract-text-webpack-plugin
module.exports = {"card-row":"card-row__1GlT7"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/planCards.scss
// module id = 1187
// module chunks = 68